export enum PublicRoutesEnum {
    CLINICS         = 'clinics',
    TYPES           = 'clinics/types',
    DENTISTS        = 'clinics/types/dentists',
    AVAILABLE_HOURS = 'clinics/types/dentists/available-hours',
    SUMMARY         = 'clinics/types/dentists/available-hours/summary',
    CONFIRMATION    = 'clinics/types/dentists/available-hours/summary/confirmation',
  }